import { createApiClient } from '@portfolio/api-client';

/**
 * The app's single API client instance.
 *
 * `VITE_API_URL` is baked in at build time. It defaults to `/api`, which in
 * production is proxied to the api container by the nginx serving this bundle,
 * so the browser never makes a cross-origin request.
 */
export const apiClient = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? '/api',
});
